import React from 'react';
import './style.scss';

interface ContentWithTooltipProps {
  tooltip: string;
}

export const ContentWithTooltip: React.FC<ContentWithTooltipProps> = ({
  tooltip,
  children,
}) => {
  return (
    <div className="content-with-tooltip__wrapper">
      {children}
      <div className="content-with-tooltip__tooltip">{tooltip}</div>
    </div>
  );
};
